import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Observable, Subject } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';

import { AuthFacade } from '@shared/data-access-auth';
import { JwtManagerService } from './jwt-manager.service';
import { RefreshTokenService } from './refresh-token.service';
import { User } from '@domgen/dgx-fe-auth/lib/common/models/user';

@Injectable({
  providedIn: 'root',
})
export class AuthStateService extends ComponentStore<never> {
  // ****** Signals (Trigger a state change or a side effect, but do not end in the state)
  private jwtUpdaterSubject = new Subject<boolean>();

  // *********** Updater Streams *********** //
  private jwtUpdaterHandler$: Observable<
    User | undefined
  > = this.jwtUpdaterSubject.pipe(
    switchMap(() => this.refreshTokenService.getRefreshToken()),
    map(() => this.jwtManagerService.decryptJWT()),
    filter((jwtDecoded) => jwtDecoded !== undefined)
  );

  // *********** Effects *********** //

  readonly updateAuthStateFromCookie = this.effect(
    (decryptJWT$: Observable<User | undefined>) =>
      decryptJWT$.pipe(
        tap((jwt) =>
          jwt
            ? this.authFacade.setAuthStateFromCookieLoggedIn(<User>jwt)
            : this.authFacade.setAuthStateFromCookieLoggedOut()
        )
      )
  )(this.jwtUpdaterHandler$);

  constructor(
    private jwtManagerService: JwtManagerService,
    private refreshTokenService: RefreshTokenService,
    private authFacade: AuthFacade
  ) {
    super();
  }

  setUpdateAuthState() {
    this.jwtUpdaterSubject.next();
  }
}
